<template>
  <div class="tw-w-full tw-flex tw-flex-col tw-gap-2 tw-text-sm tw-p-4 tw-invisible group-hover:tw-visible">
    <div class="tw-flex tw-items-center tw-gap-2">
      <i :class="assetIcon(asset)"></i>
      <span class="font-size-sm text-uppercase">{{ assetTypeName }}</span>
    </div>

    <div class="tw-line-clamp-2">{{ assetName }}</div>

    <div>
      ID: {{ asset.reference_number }}
    </div>

    <div>
      by <a :href="contributorUrlPath" class="tw-pointer-events-auto">{{ asset.user_name }}</a>
    </div>
  </div>
</template>
<script>

import GeneralMixins from "../../mixins/GeneralMixins";

export default {
  props: ['asset', 'userSlug'],
  mixins: [GeneralMixins],
  computed: {
    assetTypeName() {
      return `Stock ${this.asset.type}`
    },

    assetName() {
      if (this.asset.name) {
        return this.asset.name.split(" ").slice(0, 12).join(" ")
      } else {
        return this.asset.name
      }
    },

    contributorUrlPath() {
      if (this.userSlug) {
        return `/users/@${this.userSlug}/search`
      } else {
        return `/users/${this.asset.user_id}/search`
      }
    }
  }
}
</script>